import { ad2bs as e, bs2ad as t } from "../../../calendar-carburettor/converter/index.js";
import { maxBSYear as n, minBSYear as r } from "../../constants/calendar-date.js";
import i from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/is_date_valid.tsx
var a = t, o = e, s = (e) => {
	let t = a(e);
	if (o(t) != e) return !1;
	try {
		return i(t, "YYYY-MM-DD", !0).isValid();
	} catch {
		return !1;
	}
};
function c(e) {
	let t = n, i = r, a = e.split("-");
	return parseInt(a[0]) < t && parseInt(a[0]) > i && s(e);
}
export { c as is_date_valid, s as validate_value };

//# sourceMappingURL=is_date_valid.js.map